var app = angular.module("leonardo");

var DocumentBreadCrumb = function($scope, $state, AuthDataService, PermissionService) {

  $scope.mode = $state.current.mode ? $state.current.mode : 'normal';
  $scope.currentFolder = null;
  $scope.authDataService = AuthDataService;
  $scope.permissionService = PermissionService;

  $scope.goToFolder = function(folder) {
    var params = folder ? {pk: folder.id ? folder.id : folder} : {pk: null};
    if (folder && (folder.purpose === 7)) {
      params = {pk: $state.params.pk ? folder.id : null };
      $state.go('documents.dynamic-forms-folder', params);
      return;
    }
    switch ($scope.mode) {
      case 'normal':
        $state.go('documents.list', params);
        break;
      case 'property':
        $state.go('documents.property', params);
        break;
      case 'portfolio':
        $state.go('documents.portfolio', params);
        break;
      case 'account':
        $state.go('documents.account', params);
        break;
    }
  };

  $scope.getClassButton = function(key) {
    if(key == $scope.currentFolder.id) {
      return 'btn-go';
    }
    return 'btn-go-back-breadcrumb';
  };

  $scope.$on('folder:loaded', function ($event, folder) {
    $scope.currentFolder = folder;
  });

};

app.controller('DocumentBreadCrumb', ['$scope', '$state', 'AuthDataService', 'PermissionService', DocumentBreadCrumb]);
